import React from 'react';

import { DisputeStateType } from '@common/graphql';
import { getRedirectTargetEntity } from '@pay-bill/services';
import { Colors } from 'works/legacy/lib/style-helper';
import { DISPUTE_LABEL_OVERWRITE, DisputeState } from './dispute-state';

type InvoiceItemDisputeStateProp = DisputeStateType | 'no_dispute';

export const INVOICE_ITEM_LABEL_OVERWRITE: Record<
  InvoiceItemDisputeStateProp,
  string
> = {
  ...DISPUTE_LABEL_OVERWRITE,
  no_dispute: 'No Dispute',
};

export const InvoiceItemDisputeState = ({
  state,
  createdBy,
}: {
  state: InvoiceItemDisputeStateProp;
  createdBy?: 'Supplier' | 'Organization' | undefined;
}) =>
  state !== 'no_dispute' ? (
    <DisputeState
      state={state}
      createdBy={getRedirectTargetEntity(createdBy)}
    />
  ) : (
    <i style={{ color: Colors.steelDarker }}>No Dispute</i>
  );
